export default __webpack_public_path__ + "static/media/Human1.658d6808.png";